import type { CookieCategory } from '../types'

type ThirdPartyServices = 'perseus' | 'googleAnalytics' | 'mParticle' | 'googleTagsManager'

export const serviceConsentCategory: Record<ThirdPartyServices, CookieCategory> = {
  googleTagsManager: 'essential',
  googleAnalytics: 'functional',
  perseus: 'essential',
  mParticle: 'essential',
}
